import React from 'react';
import styles from './Eyebrow.module.css';

const Eyebrow = ({children}) => (
    <span className={styles.eyebrow}>{children}</span>
);

export default Eyebrow;
